import React, { useState, useEffect } from 'react';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { 
    Edit3, Shield, Trash2, 
    StickyNote, Save,
     Clock, 
} from 'lucide-react';

const NoteSection = ({ notes, newNote, setNewNote, onSaveNote, onDeleteNote, currentUser }) => {
    return (
        <div className="flex flex-col h-full min-h-[500px] animate-in fade-in slide-in-from-bottom-4 duration-500">
            {/* Note Input */}
            <div className="mb-8 flex gap-4 items-start">
                <img src={currentUser?.avatarUrl} className="w-10 h-10 rounded-full ring-2 ring-white shadow-sm hidden sm:block" />
                <div className="flex-1 bg-white rounded-2xl ring-1 ring-slate-200 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 transition-all overflow-hidden flex flex-col">
                    <div className="px-5 py-3.5 bg-slate-50 border-b border-slate-100 flex items-center gap-2">
                        <Edit3 size={16} className="text-slate-500" />
                        <span className="flex items-center gap-2 font-black text-sm text-slate-800 uppercase tracking-wider">Write a Note</span>
                    </div>
                    <textarea 
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        placeholder="Jot down private thoughts..."
                        className="w-full bg-transparent px-5 py-4 text-sm font-medium focus:outline-none resize-none h-24 text-slate-800 leading-relaxed"
                    />
                    <div className="px-4 py-3 bg-slate-50 border-t border-slate-100 flex justify-between items-center">
                        <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-400"><Shield size={14} /> Only visible to you</div>
                        <button onClick={onSaveNote} disabled={!newNote.trim()} className="bg-indigo-600 text-white px-5 py-2 text-xs font-bold rounded-lg hover:bg-indigo-800 active:scale-95 flex items-center gap-2">
                            <Save size={14} /> Save Note
                        </button>
                    </div>
                </div>
            </div>

            {/* Notes List */}
            <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar pb-4">
                {notes.length > 0 ? (
                    <div className="grid grid-cols-1 gap-5 auto-rows-max pt-2">
                        {notes.map((note) => (
                            <div key={note.id} className="group overflow-hidden relative bg-white p-6 rounded-2xl ring-1 ring-slate-200 shadow-sm hover:ring-indigo-300 flex flex-col min-h-[140px] pl-7">
                                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-indigo-500 group-hover:bg-indigo-600" />
                                <div className="flex justify-between items-start gap-4 mb-4">
                                    <p className="text-slate-700 font-medium text-sm leading-relaxed whitespace-pre-wrap flex-1">{note.text}</p>
                                    <button onClick={() => onDeleteNote(note.id)} className="p-2 text-slate-400 hover:text-rose-600 opacity-0 group-hover:opacity-100 transition-all"><Trash2 size={16} /></button>
                                </div>
                                <div className="mt-auto flex items-center text-[10px] font-extrabold text-slate-400 uppercase tracking-widest pt-4 border-t border-slate-100">
                                    <Clock size={12} className="mr-1.5" /> {new Date(note.timestamp).toLocaleDateString()}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="py-12 flex flex-col items-center justify-center opacity-70 m-auto h-full text-center">
                        <StickyNote className="w-8 h-8 text-slate-400 mb-4" />
                        <p className="text-base font-bold text-slate-700">No personal notes.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NoteSection;